import { useCountdown } from '@onefootprint/hooks';
import { LinkButton, LoadingSpinner } from '@onefootprint/ui';
import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useState } from 'react';
export type ResendButtonProps = {
  isResendLoading?: boolean;
  onResend: () => void;
  resendDisabledUntil?: Date;
  texts: {
    resendCta: string;
    resendCountDown: string;
  };
};
const ResendButton = ({
  isResendLoading,
  onResend,
  resendDisabledUntil,
  texts
}: ResendButtonProps) => {
  const {
    setDate,
    countdown
  } = useCountdown();
  const [resendClicked, setResendClicked] = useState(false);
  const [internalDate, setInternalDate] = useState<Date | undefined>();
  const updateCountdown = () => {
    // No changes detected
    if (internalDate === resendDisabledUntil) {
      return;
    }

    // Remember this new date, reset the button clicked state
    setInternalDate(resendDisabledUntil);
    setResendClicked(false);

    // Don't disable anymore
    if (!resendDisabledUntil) {
      setDate(new Date());
      return;
    }

    // Set button to disabled until this new date
    setDate(resendDisabledUntil);
  };
  useEffect(() => {
    updateCountdown();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resendDisabledUntil]);
  const handleClick = () => {
    setResendClicked(true);
    // Don't resend until the countdown is over
    if (countdown > 0) {
      return;
    }
    onResend();
  };
  return <div className="flex items-center flex-col justify-center gap-1 mt-4">
      <div className="min-h-[32px] text-center">
        {isResendLoading ? <LoadingSpinner /> : <LinkButton aria-label={texts.resendCta} disabled={resendClicked && countdown > 0} onClick={handleClick} data-dd-action-name="pin:resend">
            {texts.resendCta}
          </LinkButton>}
      </div>
      <AnimatePresence>
        {resendClicked && countdown > 0 && <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 10
      }}>
            <div className="text-body-2 text-tertiary mt-2">
              {texts.resendCountDown.replace('{{seconds}}', String(countdown))}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
};
export default ResendButton;